import { Chip } from '@mui/material'
import { amber, green, grey, orange, red } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'

const STATUS_COLORS = {
  AVAILABLE: {
    backgroundColor: green[300],
    color: '#000',
  },
  RESERVED: {
    backgroundColor: amber[300],
    color: '#000',
  },
  BOOKED: {
    backgroundColor: orange[300],
    color: '#000',
  },
  SOLD: {
    backgroundColor: red[300],
    color: '#000',
  },
  LEASED: {
    backgroundColor: grey[300],
    color: '#000',
  },
  UPCOMING: {
    backgroundColor: grey[300],
    color: '#000',
  },
}

const getStatusLabel = (status, t) => {
  switch (status) {
    case 'AVAILABLE':
      return t('Available')
    case 'RESERVED':
      return t('Reserved')
    case 'BOOKED':
      return t('Booked')
    case 'SOLD':
      return t('Sold')
    case 'LEASED':
      return t('Leased')
    case 'UPCOMING':
      return t('Upcoming')
    default:
      return null
  }
}

export const ChipComponent = ({ status, sx, ...props }) => {
  const { t } = useTranslation()

  if (!status) return null

  const statusColors = STATUS_COLORS[status] || {}
  const label = getStatusLabel(status, t)

  return (
    <Chip
      label={label}
      sx={{
        fontWeight: 400,
        ...statusColors,
        ...sx,
      }}
      {...props}
    />
  )
}
